import { type HTMLAttributes, forwardRef, type ReactNode } from 'react'
import { Rings } from '../Rings'
import { rewardChipVariants, rewardChipIconVariants } from './RewardChip.variants'

export interface RewardChipProps extends HTMLAttributes<HTMLDivElement> {
  reward: string
  icon: ReactNode
  accentColor?: 'none' | 'yellow' | 'green' | 'blue'
}

export const RewardChip = forwardRef<HTMLDivElement, RewardChipProps>(
  ({ reward, icon, accentColor = 'none', className, ...props }, ref) => {
    return (
      <div className={rewardChipVariants({ accentColor, className })} ref={ref} {...props}>
        <div className={rewardChipIconVariants({ accentColor })}>
          <span className="px-1">{icon}</span>
        </div>
        <div className="pr-2 z-10">
          <span className="font-formula text-base font-bold [text-shadow:0px_2px_2px_rgba(0,0,0,0.25)]">
            {reward}
          </span>
        </div>
        <div className="absolute right-0">
          <Rings accentColor={accentColor} className="scale-[0.5] right-0" variant="gradient" />
        </div>
      </div>
    )
  }
)

RewardChip.displayName = 'RewardChip'
